import { gql } from "@apollo/client";

export const componentSubGroupGenericFragment = gql`
    fragment ComponentSubGroupGeneric on ComponentSubGroup {
        id
        componentGroup {
            id
            description(languageCode: $languageCode)
            code
        }
        explosionAssetMediumResolution
        explosionAssetHighResolution
    }
`;

export const componentGroupParentGenericFragment = gql`
    fragment ComponentGroupParentGeneric on ComponentGroupParent {
        id
        componentAsset
        componentAssetFallback
        componentGroup {
            id
            code
            description(languageCode: $languageCode)
        }
        componentSubGroups {
            ...ComponentSubGroupGeneric
        }
    }
    ${componentSubGroupGenericFragment}
`;

export const wpArticleFragment = gql`
    fragment ComponentGroupWPArticle on Model {
        id
        isOem
        articleNumber
        description
        assetPath
    }
`;

export const modelFragment = gql`
    fragment ComponentGroupOverviewModel on Model {
        id
        modelTypes {
            id
            name
        }
        engineArticleNumber
        description
        articleNumber
        assetPath
        brand {
            id
            name
            shortName
            color
        }
        year
        modelSpecifications {
            id
            name
        }

        frameComponentGroupParents {
            ...ComponentGroupParentGeneric
        }
        engineComponentGroupParents {
            ...ComponentGroupParentGeneric
        }
        isWpArticle
        wpArticles {
            ...ComponentGroupWPArticle
        }
    }
    ${componentGroupParentGenericFragment}
    ${wpArticleFragment}
`;

export const componentGroupOverviewModelQuery = gql`
    query ComponentGroupOverviewModel($id: ID!, $languageCode: String) {
        model(id: $id) {
            ...ComponentGroupOverviewModel
        }
    }
    ${modelFragment}
`;
